import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getAllUsers } from '../api';
import { setAlluserDetails } from '../context/actions/allUsersAction';
import { useEffect } from 'react';
import DataTable from './DataTable';
import Avatar from '../assets/img/avatar.png';


const DBUsers = () => {
  const allUsers = useSelector((state) => state.users);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!allUsers) {
      getAllUsers().then((data) => {
        dispatch(setAlluserDetails(data));
      })
    }
  }, [])
  const truncateUserId = (userId) => {
    return userId.slice(0, 10) + "..."; // Extract the first 10 characters
  };
  const dataWithRowNumber = !allUsers
    ? []
    : allUsers.map((user, index) => ({ ...user, rowNumber: index + 1 }));

  return (
    <div className='flex items-center justify-self-center gap-4 pt-6 w-full relative' >
      <DataTable
        columns={[
          {
            title: "Số thứ tự",
            field: "rowNumber",
            headerStyle: {
              textAlign: 'center', // Center align the header title
            },
            render : (rowData) => (
              <p className='text-center'>{rowData.rowNumber}</p>
            )
          },
          {
            title: "Ảnh đại diện", field: "photoURL", render: (rowData) => (
              <img
                src={rowData.photoURL ? rowData.photoURL : Avatar}
                className='w-16 h-16 object-contain rounded-full'
              />
            ),
          }, {
            title: "Tên",
            field: "displayName",
            render: (rowData) => (
              <p>{rowData.displayName ? rowData.displayName : "Vãng lai"}</p>
            )
          },
          {
            title: "Vai trò",
            field: "role",
            render: (rowData) => (
              <p>{rowData.role ? rowData.role : "User"}</p>
            )
          },
          {
            title: "Id",
            field: "uid",
            render: (rowData) => (
              <p className='flex items-center justify-center text-sm font-semibold text-textColor'>
                {truncateUserId(rowData.uid)}
              </p>
            ),
            headerStyle: {
              textAlign: 'center', // Center align the header title
            },
          }, {
            title: "email",
            field: "email"
          }, {
            title: "Verified",
            field: "emailVerified",
            render: (rowData) => (

              < p className={`flex items-center justify-center text-sm font-semibold text-white rounded-md ${rowData.emailVerified ? "bg-green-400" : "bg-red-400"} `
              } >
                {rowData.emailVerified ? "Verified" : "Not Verified"}
              </p>
            )
          }
        ]}
        data={!dataWithRowNumber ? [] : dataWithRowNumber}
        title="Tài khoản : "
      // actions = {
      //   [
      //   {
      //     icon: "edit",
      //     tooltip: "Edit Data",
      //     onClick: (event, rowData) => {
      //       alert("Bạn muốn chỉnh sửa " + rowData.displayName)
      //     }
      //   },
      //   {
      //     icon: "delete",
      //     tooltip: "Delete Data",
      //     onClick: (event, rowData) => {
      //       if (window.confirm("Bạn có chắc chắn muốn xoá tài khoản này ?")) {
      // deleteItem(rowData.uid)
      //   .then(() => {
      //     dispatch(alertSuccess(`Delete User ID : ${rowData.uid} : ${rowData.displayName} successful`));
      //     getAllUsers().then((data) => {
      //       dispatch(setAlluserDetails(data));
      //     });
      //     setTimeout(() => {
      //       dispatch(alertNULL());
      //     }, 3000);
      //   })
      //   .catch((error) => {
      //     console.error("Error deleting User:", error);
      //   });
      // }
      // }
      // }
      // ]}
      />
    </div >
  )
}

export default DBUsers